<template>
  <div>
    <table id="table" border="1" cellpadding="0" cellspacing="0" style="width:100%">
      <caption id="tablePrintText">
        <div style="font-weight:600;letter-spacing:0px">{{hotelInfo.name}}</div>
        <div style="font-weight:600">餐饮收入情况统计日报</div>
        <div style="display: flex;justify-content:space-between;">
          <div>
            <span style="font-weight:600"
              v-if="queryShiftValue != ''">班次:{{queryShiftValue == 1 ? '早班' : queryShiftValue == 2 ? '中班' :queryShiftValue == 3 ? '晚班':queryShiftValue == 4 ? '夜班':'所有' }}
            </span>
            <span style="font-weight:600">营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</span>

          </div>
          <div>
            <span style="font-weight:600">打印人:{{employee.name}}</span>
            <span style="font-weight:600">打印时间:{{currentTime}}</span>
          </div>
        </div>
      </caption>

      <tbody>
        <tr v-show="exportShow">
          <th colspan="17">{{hotelInfo.name}}</th>
        </tr>
        <tr v-show="exportShow">
          <th colspan="17">餐饮收入情况统计日报</th>
        </tr>
        <tr v-show="exportShow">
          <th colspan="6">
            <div style="font-weight:600;textAlign:left">
              <template>营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</template>
            </div>
          </th>
          <th style="text-align:right" colspan="7">打印人:{{employee.name}} 打印时间:{{currentTime}}</th>
        </tr>

        <tr>
          <th v-for="(item,index) in salesTabelTitel" :key="index">{{item.chinese_desc}}</th>
        </tr>

        <tr v-for="tr in handoverSalesTotal" :key="tr.code">
          <td align="center" v-for="(item,index) in salesTabelTitel" :key="index">
            {{tr[item.code]?typeof(tr[item.code]) == 'number'?tr[item.code].toFixed(2):tr[item.code]:'0.00'}}</td>
        </tr>
        <tr>
          <td align="center" v-for="(td,index) in sumsSalesTotal" :key="index">
            {{typeof(td) == 'number'? td.toFixed(2):td}}</td>
        </tr>

      </tbody>
    </table>
  </div>

</template>
<script>
  import DateUtils from '@/utils/DateUtils';
  export default {
    props: {
      collectionTabelTitel: {
        type: Array,
        default: []
      },
      unCollectionAndHouse: {
        type: Array,
        default: []
      },
      handoverSalesTotal: {
        type: Array,
        default: []
      },
      salesTabelTitel: {
        type: Array,
        default: []
      },
      statisticsData: {
        type: Array,
        default: []
      },
      statisticsSum: {
        type: Object
      },
      sumsCollection: {
        type: Array,
        default: []
      },
      sumsSalesTotal: {
        type: Array,
        default: []
      },
      listQuery: {
        type: Object
      },
      exportShow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        employee: JSON.parse(localStorage.getItem('user')),
        currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
        hotelInfo: JSON.parse(localStorage.getItem('hotel')),
        queryShiftValue: '',
      }
    },
    mounted() {
      this.$bus.$on('renderQueryShiftValue', val => {
        this.queryShiftValue = val;
      });
    }

  }
</script>